__turbopack_context__.v({
  "controls": "Notification-module-scss-module__Bf3FHW__controls",
  "date": "Notification-module-scss-module__Bf3FHW__date",
  "messageBubble": "Notification-module-scss-module__Bf3FHW__messageBubble",
  "notification": "Notification-module-scss-module__Bf3FHW__notification",
  "notificationActions": "Notification-module-scss-module__Bf3FHW__notificationActions",
  "notificationAvatar": "Notification-module-scss-module__Bf3FHW__notificationAvatar",
  "notificationBadge": "Notification-module-scss-module__Bf3FHW__notificationBadge",
  "notificationText": "Notification-module-scss-module__Bf3FHW__notificationText",
  "unreadDot": "Notification-module-scss-module__Bf3FHW__unreadDot",
});
